/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../../../utils/config';

export const TEAM_URL = `${API_URL}/team`;
